import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import config from '../../config';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '..';
import facebookImage from '../../assets/hero.jpg';
import css from './FAQLandownersInfoPage.module.css';

export const FAQLandownersPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'FAQLandownersInfoPage.schemaTitle' },
    { siteTitle }
  );
  const schemaDescription = intl.formatMessage({ id: 'FAQLandownersInfoPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <div className={css.heroContent}>
              <h1 className={css.heroMainTitle}>
                <FormattedMessage id="FAQLandownersPage.heroTitle" />
              </h1>
              <h2 className={css.heroSubTitle}>
                <FormattedHTMLMessage id="FAQLandownersPage.heroDescription" />
              </h2>
            </div>
          </div>
          <div>
            <iframe
              className={css.landownerFrame}
              height="700"
              title="Embedded Wufoo Form"
              allowtransparency="true"
              frameBorder="0"
              scrolling="no"
              src="https://landtrust.wufoo.com/embed/zffv6hi1mtnbru/"
            >
              <a href="https://landtrust.wufoo.com/forms/zffv6hi1mtnbru/">Landowner FAQ form</a>
            </iframe>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

FAQLandownersPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FAQLandownersInfoPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(FAQLandownersPageComponent);

export default FAQLandownersInfoPage;
